
export class BaseStepsConfigurations { }
